const state = {
    checkedAccountList: [],
};

const mutations = {
    ADD_TO_ACCOUNT_LIST: (state, account) => {
        let list = state.checkedAccountList;
        let index = list.findIndex(item => item&&(item.company_id == account.company_id && item.plat_id == account.plat_id));
        if (index < 0) {
            state.checkedAccountList.push(account)
        }
    },
    REMOVE_FROM_ACCOUNT_LIST: (state, account) => {
        let list = state.checkedAccountList;
        let index = list.findIndex(item => item&&(item.company_id == account.company_id && item.plat_id == account.plat_id));
        if (index >= 0) {
            state.checkedAccountList.splice(index, 1);
        }
    },
    CLEAR_ACCOUNT_LIST: (state) => {
        state.checkedAccountList = [];
    },
    SET_QUERY_ACCOUNT:(state,account)=>{
        state.queryAccount = [...account];
    },
    CLEAR_QUERY_ACCOUNT:(state)=>{
        state.queryAccount = [];
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
